// components/preview/PrescriptionPreview.tsx
import React from 'react';
import { FileText } from 'lucide-react';
import type { Medication } from '../../types/medication';
import MedicationCard from '../cards/MedicationCard';

interface PrescriptionPreviewProps {
  medications: Medication[];
  searchTerm?: string;
}

const PrescriptionPreview: React.FC<PrescriptionPreviewProps> = ({
  medications,
  searchTerm = ""
}) => {
  const filteredMedications = medications.filter(
    (med) =>
      med.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
      med.orderNumber.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <div className="p-4 sm:p-6">
      <div className="bg-white rounded-2xl p-6 shadow-lg border border-gray-100">
        <h3 className="text-xl font-semibold mb-6 text-gray-800 border-b pb-3 flex items-center">
          <FileText className="mr-2 text-blue-600" size={20} />
          Aperçu de l'Ordonnance
        </h3>
        
        {filteredMedications.length === 0 ? (
          <div className="text-center py-12 text-gray-500">
            <FileText size={64} className="mx-auto mb-4 opacity-30" />
            <p className="text-lg font-medium">
              Aucune ordonnance à afficher
            </p>
            <p className="text-sm mt-2">
              Ajoutez des médicaments pour voir l'aperçu
            </p>
          </div>
        ) : (
          <div className="space-y-6">
            {filteredMedications.map((medication: Medication) => (
              <MedicationCard
                key={medication.id}
                medication={medication}
                onEdit={() => {}}
                onDelete={() => {}}
                onDuplicate={() => {}}
                showActions={false}
              />
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default PrescriptionPreview;